module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('article', {
    staticClass: "single"
  }, [(_vm.single.content != null) ? _c('div', [_c('singleTemplate', {
    attrs: {
      "post": _vm.single.content
    }
  })]) : _vm._e(), (_vm.single.content == null) ? _c('spinner') : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4516cd23!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/single/single.vue
// module id = 99
// module chunks = 1